export function useShare() {
  const canShare = 'share' in navigator

  const shareRoom = async (roomCode: string): Promise<boolean> => {
    const shareData = {
      title: 'Join my Stack25 game!',
      text: `Room code: ${roomCode}`,
      url: `${window.location.origin}/join/${roomCode}`
    }

    if (navigator.share && navigator.canShare?.(shareData)) {
      try {
        await navigator.share(shareData)
        return true
      } catch (err) {
        if ((err as Error).name !== 'AbortError') {
          console.warn('Share failed:', err)
        }
        return false
      }
    }

    return copyToClipboard(roomCode)
  }

  const copyToClipboard = async (roomCode: string): Promise<boolean> => {
    const text = `Join my Stack25 game! Room code: ${roomCode}\n${window.location.origin}/join/${roomCode}`
    
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch (err) {
      const textArea = document.createElement('textarea')
      textArea.value = text
      textArea.style.position = 'fixed'
      textArea.style.left = '-9999px'
      document.body.appendChild(textArea)
      textArea.select()
      
      try {
        document.execCommand('copy')
        return true
      } catch {
        return false
      } finally {
        document.body.removeChild(textArea)
      }
    }
  }

  return {
    canShare,
    shareRoom,
    copyToClipboard
  }
}
